// 首頁左上：分級標示（輔 15）、警語、服務條款與隱私權政策連結
// 對應 docs/PRD-Freemium.md 第 5.3 節：起始頁要標示分級標識（至少 45×45 px）與「不得利用遊戲賭博」警語
//
// 上線前要換成分級資料庫提供的官方標識圖檔（目前為程式繪製）。
//
// === 使用圖片 ===
// 無 — 純程式繪製（Phaser.Graphics＋Text）

import type Phaser from 'phaser';
import { PAGE_THEME } from './page-skin';

// ---- 版面常數 ----
const PLATE_X = 16; // 底板左上
const PLATE_Y = 14;
const PLATE_WIDTH = 300;
const PLATE_HEIGHT = 74;
const PLATE_RADIUS = 14;
const PLATE_BG = 0x1a0b05;
const PLATE_ALPHA = 0.72;
const BADGE_SIZE = 54; // 分級框（法規至少 45×45 px）
const BADGE_X = PLATE_X + 12 + BADGE_SIZE / 2;
const BADGE_Y = PLATE_Y + PLATE_HEIGHT / 2;
const BADGE_COLOR = 0xd35400;
const TEXT_X = PLATE_X + 12 + BADGE_SIZE + 12;
const WARNING_Y = PLATE_Y + 24;
const LINK_Y = PLATE_Y + 52;
const TEXT_FONT = 18;
const LINK_GAP = 14;

export const TERMS_URL = '/legal/terms.html';
export const PRIVACY_URL = '/legal/privacy.html';

export const createHomeLegalBadge = (scene: Phaser.Scene, depth: number): void => {
  const g = scene.add.graphics().setDepth(depth);
  g.fillStyle(PLATE_BG, PLATE_ALPHA);
  g.fillRoundedRect(PLATE_X, PLATE_Y, PLATE_WIDTH, PLATE_HEIGHT, PLATE_RADIUS);
  g.fillStyle(0xffffff, 1);
  g.fillRoundedRect(BADGE_X - BADGE_SIZE / 2, BADGE_Y - BADGE_SIZE / 2, BADGE_SIZE, BADGE_SIZE, 8);
  g.lineStyle(4, BADGE_COLOR);
  g.strokeRoundedRect(
    BADGE_X - BADGE_SIZE / 2,
    BADGE_Y - BADGE_SIZE / 2,
    BADGE_SIZE,
    BADGE_SIZE,
    8
  );
  scene.add
    .text(BADGE_X, BADGE_Y, '輔15', {
      color: '#d35400',
      fontFamily: PAGE_THEME.font,
      fontSize: '19px',
      fontStyle: 'bold',
    })
    .setOrigin(0.5)
    .setDepth(depth);
  scene.add
    .text(TEXT_X, WARNING_Y, '本遊戲不得利用於賭博', {
      color: '#fff1cf',
      fontFamily: PAGE_THEME.font,
      fontSize: `${TEXT_FONT}px`,
    })
    .setOrigin(0, 0.5)
    .setDepth(depth);
  const link = (x: number, label: string, url: string): Phaser.GameObjects.Text =>
    scene.add
      .text(x, LINK_Y, label, {
        color: '#e7c26b',
        fontFamily: PAGE_THEME.font,
        fontSize: `${TEXT_FONT}px`,
      })
      .setOrigin(0, 0.5)
      .setDepth(depth)
      .setInteractive({ useHandCursor: true })
      .on('pointerup', () => window.open(url, '_blank'));
  const terms = link(TEXT_X, '服務條款', TERMS_URL);
  link(terms.x + terms.width + LINK_GAP, '隱私權政策', PRIVACY_URL);
};
